'use strict';

import React from 'react';
import Caterpie from '../010-caterpie';
import Metapod from '../011-metapod';
import Weedle from '../013-weedle';
import Kakuna from '../014-kakuna';
import Jigglypuff from '../039-jigglypuff';
import Diglett from '../050-diglett';
import Voltorb from '../100-voltorb';
import Electrode from '../101-electrode';
import Exeggcute from '../102-exeggcute';
import Koffing from '../109-koffing';
import Eevee from '../133-eevee';
import Vaporeon from '../134-vaporeon';
import Jolteon from '../135-jolteon';
import Flareon from '../136-flareon';
import './App.scss';

const App = () => (
  <div className="container">
    <h1 className="title">Pokémons</h1>
    <Caterpie />
  </div>
)

export default App;



/** WEBPACK FOOTER **
 ** ./source/app/App.js
 **/